import { render } from "./LessonView.vue?vue&type=template&id=50de8e64"
import script from "./LessonView.vue?vue&type=script&lang=js"
export * from "./LessonView.vue?vue&type=script&lang=js"

import "./LessonView.vue?vue&type=style&index=0&id=50de8e64&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__